    <div class="container-fluid">
        <div class="row mt-4">
            <div class="col">
                <h5 class="blue"><i class="fas fa-plus"></i>&nbsp;Crear estación</h5>
            </div>
        </div>
        <hr>
        <form #formNuevoEstacion="ngForm" (ngSubmit)="formSubmit(formNuevoEstacion)" novalidate="">
            <div class="container-fuid"
                style="overflow-y: auto; padding-right: 20px; overflow-x: hidden;">
                <div class="row">
                    <div class="col col-12">
                        <label class="form-label">IATA <small>(Solo se admiten mayúsculas)</small>:</label>
                        <br>
                        <input type="text" autocomplete="off" class="form-control form-control-sm custom-input" placeholder="IATA"
                            name="txtIATA" #txtIATA="ngModel" [(ngModel)]='EstacionRQ.IATA' maxlength="3" pattern="^[A-ZÀ-Ñ\s]{3}$" required>
                        <!-- <p-dropdown name="slcEstaciones" #slcEstaciones="ngModel" [options]="estaciones" [filter]="true"
                            filterBy="label" [style]="{'width':'150px'}" [(ngModel)]="UsuarioRQ.idEstacion"
                            optionLabel="label" optionValue="value" [required]="true"></p-dropdown> -->

                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col col-12">
                        <label class="form-label">Descripción:</label>
                        <br>
                        <textarea style="height: 250px;" class="form-control form-control-sm custom-input" placeholder="Descripción"
                            name="txtAreaDescripcion" #txtArea="ngModel" [(ngModel)]='EstacionRQ.descripcion' maxlength="255">
                        </textarea>
                    </div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col text-end">
                    <button type="button" (click)="onClose()" class="btn btn-sm rounded-button btn-secondary">
                        <i class="fa fa-arrow-left"></i>
                        Regresar
                    </button>
                    <button [disabled]="!formNuevoEstacion.form.valid"
                        class="side-space btn btn-sm rounded-button btn-success">
                        Aceptar
                        <i class="fa fa-check"></i>
                    </button>
                </div>
            </div>
        </form>

    </div>